import { Type } from 'class-transformer';
import { DimensionOptionCodeRawDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-option-code-raw-dto';

export class VendorLineItemCodingTemplateRawDto {
    vendorLineItemTemplateId: number;
    enabled: boolean;
    sequence: number;
    itemAmount: number;
    description: string;
    subAccountId: number;
    subCategoryId: number;

    @Type(() => DimensionOptionCodeRawDto)
    dimensions: Array<DimensionOptionCodeRawDto>;
    crudAction: string;
}
